import { InjectionToken } from '@angular/core';
import { Observable, SchedulerLike } from 'rxjs';
import { SalesTeamInterface } from '@vendasta/sales-common';

export interface SalesTeamsService {
  arrayOfSalesTeamMembers$: Observable<string[][]>;

  getSalesTeams$(partnerId: string, marketId: string, scheduler?: SchedulerLike): Observable<SalesTeamInterface[]>;

  salesTeamIdsToArrayOfSalesPeopleIds(salesTeamIds: string[]): void;
}
export interface SalesTeamMultiSelectConfig {
  partnerId$: Observable<string>;
  marketId$: Observable<string>;
  salesTeamsService: SalesTeamsService;
}

export const SALES_TEAM_MULTI_SELECT_CONFIG_TOKEN = new InjectionToken<SalesTeamMultiSelectConfig>(
  'sales team multi select config token',
);
export const PARTNER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken('token for current partner id');
export const MARKET_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken('token for current market id');
export const SALES_TEAMS_SERVICE_TOKEN: InjectionToken<SalesTeamsService> = new InjectionToken(
  'token for a service needed by this filter',
);
